import ReactDOM from 'react-dom/client'
import { initiateSentry } from '~/services/sentry'
import { isElectron } from '~/utils/common'
import '~/utils/polyfill'

import App from './app'
import './app.global.css'
import { applyFeatureFlagOverrides, renderOnce } from './bootstrap'

const isFullPopup =
  isElectron && ['/popup', '/popup/'].includes(window.location.pathname)

initiateSentry(isFullPopup ? { tags: { popup_mode: 'full' } } : undefined)
applyFeatureFlagOverrides()

renderOnce((root) => {
  ReactDOM.createRoot(root).render(<App />)
})
